import React from 'react';

export default function LoadingProvider({ children }) {
    return <React.Suspense fallback={<div>Loading..</div>}>
        { children }
    </React.Suspense>
}
